import { AutogenModelEdiFunctionalSeg, AutogenRowEdiFunctionalSeg } from "./autogen/AutogenModelEdiFunctionalSeg";

export class ModelEdiFunctionalSeg extends AutogenModelEdiFunctionalSeg<RowEdiFunctionalSeg> {
    constructor() {
        super(RowEdiFunctionalSeg);
    }
}

export class RowEdiFunctionalSeg extends AutogenRowEdiFunctionalSeg {
}